import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';
import QuizReportQuestion from './QuizReportQuestion';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import './quizReport.css';

const QuizReportAdmin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const quizId = queryParams.get('id');
  const quizState = location?.state || {};

  const [data, setData] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [viewType, setViewType] = useState('list');
  const [currentSubject, setCurrentSubject] = useState([]);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const loadingIndicator = document.querySelector('#loading-indicator');
      if (loadingIndicator) loadingIndicator.style.display = 'flex';
      setLoading(true);
      try {
        const attemptedQuestionsSnapshot = await db
          .collection(`attemptedQuizTest/${quizId}/attemptedQuestion`)
          .get();

        const attemptedQuestionsPromises = attemptedQuestionsSnapshot.docs.map(
          async (doc) => {
            const attemptedQuestionData = doc.data();

            const questionSnapshot = await db
              .collection('QuestionsV2')
              .where('id', '==', attemptedQuestionData.QuationsV2Id)
              .get();

            if (!questionSnapshot.empty) {
              const questionDoc = questionSnapshot.docs[0];
              const questionData = questionDoc.data();

              const imagesSnapshot = await db
                .collection('QuestionsV2')
                .doc(questionDoc.id)
                .collection('Images')
                .get();

              // Extract image URLs or data
              const images = imagesSnapshot.docs.map((imgDoc) => imgDoc.data());

              return {
                subject: questionData.subject,
                questionDetails: { ...questionData, images },
                ...attemptedQuestionData,
              };
            } else {
              return null;
            }
          }
        );

        const attemptedQuestions = await Promise.all(
          attemptedQuestionsPromises
        );

        const validQuestions = attemptedQuestions.filter((q) => q !== null)
        .sort((a, b) => (a.questionNumber || 0) - (b.questionNumber || 0));

        const groupedBySubject = validQuestions.reduce((acc, item) => {
          if (!acc[item.subject]) {
            acc[item.subject] = [];
          }
          acc[item.subject].push(item);
          return acc;
        }, {});
        setCurrentSubject(Object?.keys(groupedBySubject)?.map((key) => key)[0]);
        setData(groupedBySubject);
      } catch (error) {}

      if (loadingIndicator) {
        loadingIndicator.style.display = 'none';
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  function getNumber(value) {
    const mapping = { a: 1, b: 2, c: 3, d: 4 };
    return mapping[value] || null; // Returns null if input is not a, b, c, or d
  }

  const currectAnswer =
    data[currentSubject] &&
    data[currentSubject]?.length > 0 &&
    data[currentSubject][currentQuestion]?.questionDetails[
      data[currentSubject][currentQuestion]?.questionDetails?.primaryLanguage
    ]
      ? getNumber(
          data[currentSubject][currentQuestion]?.questionDetails[
            data[currentSubject][currentQuestion]?.questionDetails
              ?.primaryLanguage
          ]?.correctOption
            ?.replace('Option ', '')
            ?.toLowerCase()
        )
      : '';

  console.log(data, 'dataaaaaa');

  const groupButtonStyle = {
    cursor: 'pointer',
    border: '0',
    padding: '3px 10px 3px 10px',
    outline: 'none',
  };

  return (
    <>
      {!loading && (
        <div className='content'>
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              alignContent: 'center',
              gap: '24px',
            }}
          >
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              <button
                onClick={() => navigate('/admin/quiz')}
                style={{
                  border: '0',
                  padding: '0 ',
                  outline: 'none',
                  background: 'transparent',
                  color: 'white',
                  cursor: 'pointer',
                }}
              >
                <KeyboardBackspaceIcon />
              </button>
              <p style={{ margin: '0', fontWeight: '700' }}>
                {' '}
                {quizState?.quizName}
              </p>
            </div>
            <div
              style={{
                display: 'flex',
                width: 'fit-content',
                justifyContent: 'end',
                alignContent: 'center',
                borderRadius: '4px',
                overflow: 'hidden',
                border: '1px solid #007bff',

                // gap: '24px',
              }}
            >
              <button
                onClick={() => setViewType('list')}
                style={{
                  ...groupButtonStyle,
                  ...{
                    background: viewType === 'list' ? '#007bff' : 'transparent',
                    color: viewType === 'list' ? 'white' : '#007bff',
                  },
                }}
              >
                List View
              </button>
              <button
                onClick={() => {
                  setCurrentQuestion(0);
                  setViewType('single');
                }}
                style={{
                  ...groupButtonStyle,
                  ...{
                    background:
                      viewType === 'single' ? '#007bff' : 'transparent',
                    color: viewType === 'single' ? 'white' : '#007bff',
                  },
                }}
              >
                Single View
              </button>
            </div>
          </div>

          <div
            style={{
              padding: ' 20px  ',
              borderRadius: '8px',
              margin: '20px 28px',

              fontSize: '14px',
              fontWeight: 'bold',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              border: '1px solid #ddd',
              backgroundColor: '#26293c',
            }}
          >
            <p>Student: {quizState?.userName}</p>
            <div
              style={{
                display: 'flex',
                width: 'fit-content',
                justifyContent: 'end',
                alignContent: 'center',
                borderRadius: '4px',
                overflow: 'hidden',
                border: '1px solid #007bff',

                // gap: '24px',
              }}
            >
              {Object?.keys(data)?.map((key) => (
                <button
                  onClick={() => {
                    setCurrentSubject(key);
                    setCurrentQuestion(0);
                  }}
                  style={{
                    ...groupButtonStyle,
                    ...{
                      background:
                        currentSubject === key ? '#007bff' : 'transparent',
                      color: currentSubject === key ? 'white' : '#007bff',
                    },
                  }}
                  key={key}
                >
                  {key}
                </button>
              ))}
            </div>
          </div>

          {/* <div style={{ maxHeight: '70vh', overflowY: 'auto' }}> */}
          {viewType === 'list' &&
            data[currentSubject] &&
            data[currentSubject]?.length > 0 &&
            data[currentSubject]?.map((item, i) => {
              const correctOption = getNumber(
                item?.questionDetails[
                  item?.questionDetails?.primaryLanguage
                ]?.correctOption
                  ?.replace('Option ', '')
                  ?.toLowerCase()
              );

              return (
                <QuizReportQuestion
                language={item?.questionDetails?.primaryLanguage}
                  viewType={viewType}
                  explanation={
                    item?.questionDetails[
                      item?.questionDetails?.primaryLanguage
                    ]?.correctOptionExplanation
                  }
                  currentQuestion={i}
                  question={
                    item?.questionDetails[
                      item?.questionDetails?.primaryLanguage
                    ]?.question
                  }
                  yourAns={item?.yourAns}
                  selectedAns={
                    item?.yourAns
                      ? item?.questionDetails[
                          item?.questionDetails?.primaryLanguage
                        ]?.options[item?.yourAns ]
                      : 'Skipped'
                  }
                  correctAns={correctOption}
                  options={
                    item?.questionDetails[
                      item?.questionDetails?.primaryLanguage
                    ]?.options
                  }
                  images={item?.questionDetails?.images}
                />
              );
            })}

          {viewType === 'single' && (
            <>
              <QuizReportQuestion
              language={data[currentSubject][currentQuestion]?.questionDetails?.primaryLanguage}
                viewType={viewType}
                explanation={
                  data[currentSubject][currentQuestion]?.questionDetails[
                    data[currentSubject][currentQuestion]?.questionDetails
                      ?.primaryLanguage
                  ]?.correctOptionExplanation
                }
                currentQuestion={currentQuestion}
                question={
                  data[currentSubject][currentQuestion]?.questionDetails[
                    data[currentSubject][currentQuestion]?.questionDetails
                      ?.primaryLanguage
                  ]?.question
                }
                yourAns={data[currentSubject][currentQuestion]?.yourAns}
                selectedAns={
                  data[currentSubject][currentQuestion]?.yourAns
                    ? data[currentSubject][currentQuestion]?.questionDetails[
                        data[currentSubject][currentQuestion]?.questionDetails
                          ?.primaryLanguage
                      ]?.options[
                        data[currentSubject][currentQuestion]?.yourAns 
                      ]
                    : 'Skipped'
                }
                correctAns={currectAnswer}
                options={
                  data[currentSubject][currentQuestion]?.questionDetails[
                    data[currentSubject][currentQuestion]?.questionDetails
                      ?.primaryLanguage
                  ]?.options
                }
                images={
                  data[currentSubject][currentQuestion]?.questionDetails?.images
                }
              />
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  gap: '12px',
                  padding: '0 30px',
                }}
                className='quiz-buttons'
              >
                <button
                  style={{
                    opacity: currentQuestion == 0 ? '.5' : '1',
                  }}
                  className='btn btn-secondary'
                  onClick={() => {
                    if (currentQuestion + 1 > 1)
                      setCurrentQuestion((prev) => prev - 1);
                  }}
                >
                  Prev
                </button>
                <button
                  style={{
                    opacity:
                      data[currentSubject]?.length - 1 > currentQuestion
                        ? '1'
                        : '.5',
                  }}
                  onClick={() => {
                    if (data[currentSubject]?.length - 1 > currentQuestion)
                      setCurrentQuestion((prev) => prev + 1);
                  }}
                  className='btn btn-primary'
                >
                  Next
                </button>
              </div>
            </>
          )}
          {/* </div> */}
        </div>
      )}
    </>
  );
};

export default QuizReportAdmin;
